import { RequestLogService } from 'services';
import { ResponseExceptionHandlerHelper } from 'utils';

export const RequestLogManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return RequestLogService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const buscarPorId = (Id) => {
    return RequestLogService.buscarPorId(Id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportarExcel = (where) => {
    return RequestLogService.exportarExcel(where).then((res) => {
      return res;
    });
  };

  return { listado, buscarPorId, exportarExcel };
})();